import React from 'react';
import { Forms } from '@ofself/shell';
import './FormGroup.css';

/**
 * FormGroup — label, hint, control, error.
 *
 * `block` renders the kit's form-folio cell instead of the local stack: the
 * label seated INSIDE the block in the tracked mono voice, the hint under it,
 * the control bare beneath with no enclosure of its own, and a hairline seam
 * where the next block meets it. It is the same grammar the sign-in page wears
 * (`Forms.Field`, @ofself/shell) — "one field, one block; the block IS the
 * input".
 *
 * Opt-in rather than the default because a cell is page-scale: 44px of padding
 * and a 150px floor is right for a form that is the page and far too heavy for
 * a field in a modal or an inline editor, which is most of this app's other
 * thirteen call sites.
 */
const FormGroup = ({ label, helpText, error, required, block, children, className = '' }) => {
  if (block) {
    return (
      <Forms.Field label={label} hint={helpText} required={required} error={error} className={className}>
        {children}
      </Forms.Field>
    );
  }

  return (
    <div className={`p-form-group ${error ? 'p-form-group--error' : ''} ${className}`}>
      {label && (
        <label className="p-form-group__label">
          {label}
          {required && <span className="p-form-group__required"> *</span>}
        </label>
      )}
      {helpText && !error && (
        <span className="p-form-group__help">{helpText}</span>
      )}
      {children}
      {error && (
        <span className="p-form-group__error">{error}</span>
      )}
    </div>
  );
};

export default FormGroup;
